import React, {Component} from 'react';
import { compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import CSelect from '@/components/CForm/CSelect'
import CInput from '@/components/CForm/CInput'
import { tableData1,tableData2} from './data'
import './index.scss'
import {message} from "antd";

import { getpfcx } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {Button, Modal} from 'antd'
@CBaseComponent
class GoodsManageList extends Component {
    constructor(props) {
        super(props);
        this.getListData = this.getListData.bind(this);
        this.modalOk = this.modalOk.bind(this);
        this.modalCancel = this.modalCancel.bind(this);
        this.searchHandler = this.searchHandler.bind(this)
        this.change = this.change.bind(this)
        this.resetHander = this.resetHander.bind(this)
        this.handleCanceldialog = this.handleCanceldialog.bind(this)
        this.onTableChange = this.onTableChange.bind(this)
    }

    state = {
        columns: tableData1.tHead,
        dataSource: tableData1.tBody,
        dataSourceall: tableData1.tBody,
        page: tableData1.tPage,
        loading: true,
        level: 0,
        modal: {
            title: '',
            visible: false,
        },
        form:{
            miid:'',
            provinceid:'',
            museumname:'',
            voter:'',
            mincnt:'',
            maxcnt:'',
        },
        list:[
            {id:'99',name:'全部'},
            {id:'00',name:'中央'},
            {id:'11',name:'北京'},
            {id:'12',name:'天津'},
            {id:'13',name:'河北'},
            {id:'14',name:'山西'},
            {id:'15',name:'内蒙古'},
            {id:'21',name:'辽宁'},
            {id:'22',name:'吉林'},
            {id:'23',name:'黑龙江'},
            {id:'31',name:'上海'},
            {id:'32',name:'江苏'},
            {id:'33',name:'浙江'},
            {id:'34',name:'安徽'},
            {id:'35',name:'福建'},
            {id:'36',name:'江西'},
            {id:'37',name:'山东'},
            {id:'41',name:'河南'},
            {id:'42',name:'湖北'},
            {id:'43',name:'湖南'},
            {id:'44',name:'广东'},
            {id:'45',name:'广西'},
            {id:'46',name:'海南'},
            {id:'50',name:'重庆'},
            {id:'51',name:'四川'},
            {id:'52',name:'贵州'},
            {id:'53',name:'云南'},
            {id:'54',name:'西藏'},
            {id:'61',name:'陕西'},
            {id:'62',name:'甘肃'},
            {id:'63',name:'青海'},
            {id:'64',name:'宁夏'},
            {id:'65',name:'新疆'},
            {id:'90',name:'新疆生产建设兵团'},
        ],
        isModalVisible:false,
        columns1: tableData2.tHead,
        dataSource1: tableData2.tBody,
        dataSource1all: tableData2.tBody,
        page1: tableData2.tPage,
        voterlist:[]
    };

    modalCancel() {
        this.setState({
            modal: {...this.state.modal, visible: false},
            dataSource1: [],
            dataSource1All: []
        })
    }

    searchHandler() {
        this.getListData()
    }
    resetHander(){
        const params = JSON.parse(JSON.stringify(this.state.form))
        for (const key in params){
            params[key] = ''
        }
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        params.miid = userInfo[0].miid
        this.setState({
            form:params
        },()=>{
            this.getListData();
        })
    }

    modalCancel() {
        this.setState({
            modal: {...this.state.modal, visible: false},
            deleteid: ''
        })
    }

    modalOk() {
        // const params = {
        //   id: this.state.deleteid
        // }
        // expertdelete(params).then(res=>{
        //   if (res.statecode === 0) {
        //     message.success('删除成功');
        //     this.modalCancel()
        //     this.getListData()
        //   } else {
        //     message.error('删除失败');
        //   }
        // })
    }

    change(type,value){
        this.setState({
            form:{...this.state.form,[type]:value}
        })
    }

    onTableChange(data){
        let d =this.state.dataSourceall
        var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
        var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
        var newDataList = [];
        for(var i = bIndex;i < eIndex;i++){
            if (d[i]) {
                newDataList.push(d[i]);
            }
        }
        this.setState({
            page: {...this.state.page, ...data.data},
            dataSource:newDataList
        })
    }

    // 获取用户列表数据
    getListData() {
        this.setState({
            loading: true
        });
        getpfcx(this.state.form).then(res => {
            if (res.statecode === 0) {
                let d = JSON.parse(JSON.stringify(res.records))
                let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)

                this.setState({
                    loading: false,
                    dataSource:data,
                    dataSourceall:res.records,
                    page:{...this.state.page,total:res.records.length}
                });
            }
        }).catch(err => {
            console.log(err, 'rttt')
        })
    }


    getAlert(result){
        if (result.voterlist === ''){
            message.error('暂无投票人')
            return
        } else {
            this.setState({
                voterlist:result.voterlist
            },()=>{
                this.setState({
                    isModalVisible:true
                })
            })
        }
    }

    handleCanceldialog(){
        this.setState({
            isModalVisible:false
        })
    }

    componentWillMount() {

    }

    componentDidMount() {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.setState({
            form:{...this.state.form,miid:userInfo[0].miid}
        },()=>{
            this.getListData();
        })
    }

    render(){
        return (
            <div className='user-manage-list'>
                <div className='flex filter-wrap' style={{width: '100%',flexWrap:'wrap',justifyItems:'self-start'}}>
                        <div style={{marginBottom: '10px',width:'33.3%'}} >
                            <label htmlFor="">
                                推介年度：</label>
                            <CSelect
                                value={this.state.form.miid}
                                placeholder='请选择推介年度'
                                style={{width: '200px'}}
                                onChange={(value)=>{this.change('miid',value)}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'33.3%'}}>
                            <label htmlFor="">
                                博物馆所处省份：</label>
                            <CSelect
                                value={this.state.form.provinceid}
                                options={this.state.list}
                                placeholder='请选择所处省份'
                                style={{width: '100px'}}
                                onChange={(value)=>{this.change('provinceid',value)}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'33.3%'}}>
                            <label htmlFor="">
                                博物馆名称：</label>
                            <CInput
                                value={this.state.form.museumname}
                                placeholder='请输入名称'
                                style={{width: '200px'}}
                                onChange={(value)=>{this.change('museumname',value)}}

                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'33.3%'}}>
                            <label htmlFor="">
                                得票数量：</label>
                            <CInput
                                value={this.state.form.mincnt}
                                style={{width: '60px'}}
                                onChange={(value)=>{this.change('mincnt',value)}}

                            />
                            <span style={{margin: '0 10px'}}>分至</span>
                            <CInput
                                value={this.state.form.maxcnt}
                                style={{width: '60px', marginRight: '10px'}}
                                onChange={(value)=>{this.change('maxcnt',value)}}

                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'33.3%'}}>
                            <label htmlFor="">
                                投票人姓名：</label>
                            <CInput
                                value={this.state.form.voter}
                                placeholder='请输入投票人姓名'
                                style={{width: '200px'}}
                                onChange={(value)=>{this.change('voter',value)}}
                            />
                        </div>
                        <div style={{marginBottom: '10px',width:'33.3%'}}>
                            <CButton type='primary' onClick={this.searchHandler}>查询</CButton>
                            <CButton onClick={this.resetHander} style={{marginLeft:'20px'}}>重置</CButton>
                        </div>
                    </div>
                <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns}
                        dataSource={this.state.dataSource}
                        page={this.state.page}
                        onTableChange={this.onTableChange}
                >
                    <div
                        slot='index'
                        render={(text, record, index) => (
                            <div className='operate'>
                                {index + 1}
                            </div>
                        )}/>
                    <div
                        slot='operate'
                        render={(text, record, index) => (
                            <div className='operate'>
                                <CButton type='primary' onClick={()=>{this.getAlert(record)}}>查看</CButton>
                            </div>
                        )}/>
                </CTable>
                <Modal title='投票人列表'
                       visible={this.state.isModalVisible}
                       onCancel={this.handleCanceldialog}
                       centered={true}
                       width={'400px'}
                       footer={[
                           <Button key="submit" type="primary" onClick={this.handleCanceldialog}>
                               取消
                           </Button>
                       ]}
                >
                    {this.state.voterlist}
                </Modal>
            </div>
        )
    }
}

export default compose(withRouter)(GoodsManageList);
